import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import green from '@material-ui/core/colors/green'
import EditIcon from "@material-ui/icons/Edit"
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from '@material-ui/core/Divider';
import MUIDataTable from "mui-datatables";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";
import axios from "axios";
import {withSnackbar} from 'notistack';
import {urlConfig} from './config'
import ContentAdvisoryConfig from './ContentAdvisoryConfig';

const styles = theme => ({
    container: {
        position: 'relative',
    },
});

const rootUrl = urlConfig.bffUrl;

// const rootUrl = "http://localhost:1339";


class ConfigContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            active: true,
            contentType: 0,
            errorMessages: {},
            open: false,
            columnsData: [],
            ageRatingsData: [],
            chipsData: [],
            chipInputs: [],
            AUTH_MAM_CONFIG: false
        }
        ;


    }


    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };


    handleDelete = data => () => {

    };

    handleClickOpen = (event) => {

        let chipsData = [];

        console.log(event);

        let rowData = event.rowData;


        let self = this;
        if (this.state.columnsData && this.state.columnsData.length > 0) {
            this.state.columnsData.forEach((columnElement, index) => {
                console.log(rowData[index + 1]);
                if (columnElement.name !== "Action") {
                    let elementToPush = {};
                    elementToPush.name = self.state.columnsData[index + 1].name;
                    if (rowData[index + 1] && rowData[index + 1].length > 0) {
                        elementToPush.ageRatings = rowData[index + 1].split(',');

                        chipsData.push(elementToPush);
                    } else {
                        if (elementToPush.name && elementToPush.name !== "Action") {
                            chipsData.push(elementToPush);
                        }
                    }
                }
            })
        }

        // {
        //     name: "Little Kids",
        //         ageRatings: ["13+"]
        // },

        this.setState({open: true, ratingRegionToEdit: rowData[0], chipsData: chipsData});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    componentDidMount() {
        this.getColumnsData();

        if (sessionStorage.AUTH_MAM_CONFIG == "true") {
            this.setState({AUTH_MAM_CONFIG: true});
        }
        let self = this;
        window.addEventListener('storage', (event) => {
            console.log(event);
            if (event.key && event.key === "AUTH_MAM_CONFIG") {
                if (event.newValue && event.newValue == "true") {
                    self.setState({AUTH_MAM_CONFIG: true})
                } else if (event.newValue && event.newValue == "false") {
                    self.setState({AUTH_MAM_CONFIG: false})
                }
            }
        })
    }


    saveRatings() {

        let self = this;
        let serverUrl = `${rootUrl}/config/saveAgeRating`;
        // let serverUrl = urlConfig.refereDataUrl+'ratings/ageRating/regional';

        const saveRatingsInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 120000,
            headers: {'ACCEPT': 'application/json;charset=UTF-8'}
        });

        self.setState({
            errorMessages: {},
            submitting: true
        });

        let chipsData = self.state.chipsData;
        let regionsData = {};

        regionsData["region"] = self.state.ratingRegionToEdit;
        regionsData["ratings"] = {};
        chipsData.forEach((data, index) => {
            if (data.ageRatings && data.ageRatings.length > 0) {
                regionsData.ratings[self.state.columnsData[index + 1].name.toString()] = data.ageRatings.join(",");
            }
        });


        console.log(regionsData);

        saveRatingsInstance.post('/', regionsData)
            .then(function (response) {
                self.setState({response: {}});

                if (response) {

                    self.props.enqueueSnackbar('Ratings saved successfully!', {
                        variant: 'success', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });

                    self.setState({
                        open: false
                    });

                    self.getColumnsData();

                } else {

                    self.props.enqueueSnackbar('Failed to save ratings.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                    self.setState({});
                }

            }, function () {
                self.props.enqueueSnackbar('Failed to save ratings.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
                self.setState({});

            })
            .catch(function (error) {
                self.props.enqueueSnackbar('Failed to save ratings.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
                self.setState({})

            });
    }

    getColumnsData() {

        let self = this;

        let serverUrl = rootUrl + '/config/ageRatingReference/';
        const ratingReferenceInstance = axios.create({
            baseURL: `${serverUrl}`,
            timeout: 120000,
            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
        });


        self.setState({
            errorMessages: {}
        });


        ratingReferenceInstance.get()
            .then(function (response) {
                self.setState({columnsData: []});

                if (response.data) {
                    if (response.data.status === "SUCCESS") {
                        if (response.data.entity) {
                            let columns = [
                                {
                                    name: "Region",
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {

                                            return (
                                                <Typography variant={'subtitle2'}>{value}</Typography>
                                            );

                                        }
                                    }

                                }];

                            let columnsReferenceResponse = response.data.entity.ratings.content_age_rating;
                            if (columnsReferenceResponse && columnsReferenceResponse.length > 0) {

                                columnsReferenceResponse.forEach(function (data) {
                                    columns.push({'name': data.name});

                                })
                            }

                            columns.push({
                                name: "Action",
                                options: {
                                    customBodyRender: (value, tableMeta, updateValue) => {

                                        return (
                                            <IconButton onClick={self.handleClickOpen.bind(this, tableMeta)}
                                                        aria-label="Edit">
                                                <EditIcon/>
                                            </IconButton>
                                        );

                                    },
                                    filter: false,
                                    download: false
                                }
                            });

                            self.setState({columnsData: columns}, function () {
                                const regionalRatingsInstance = axios.create({
                                    baseURL: `${serverUrl}regional`,
                                    timeout: 120000,
                                    headers: {'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
                                });

                                regionalRatingsInstance.get()
                                    .then(function (response) {
                                        self.setState({ageRatingsData: []});

                                        let ageRatingsResponse = [];
                                        if (response.data) {
                                            if (response.data.status === "SUCCESS") {
                                                if (response.data.entity) {
                                                    ageRatingsResponse = response.data.entity;
                                                } else {
                                                    if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                                        self.setState({
                                                            columnsData: {},
                                                            errorMessages: response.data.genericMessages
                                                        });
                                                    }
                                                }
                                            } else {

                                            }
                                        } else {
                                            self.setState({});
                                        }

                                        self.setState({columnsData: columns});

                                        const regionReferenceInstance = axios.create({
                                            baseURL: rootUrl + `/config/referenceRegions`,
                                            timeout: 120000,
                                            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v1+json;charset=UTF-8'}
                                        });

                                        regionReferenceInstance.get()
                                            .then(function (response) {
                                                self.setState({ageRatingsData: []});


                                                if (response.data) {
                                                    if (response.data.status === "SUCCESS") {
                                                        if (response.data.entity) {

                                                            let ageRatingsOrdered = [];
                                                            let referenceRegions = response.data.entity;

                                                            if (referenceRegions && referenceRegions.length > 0) {

                                                                referenceRegions.forEach(function (regionElement, indexRegion) {

                                                                    let elementToPush = [];
                                                                    elementToPush.push(regionElement.name);

                                                                    self.state.columnsData.forEach(function (columnElement, indexColumn) {

                                                                        if (indexColumn === 0) {

                                                                        } else {
                                                                            elementToPush.push("");
                                                                        }

                                                                    });

                                                                    ageRatingsOrdered.push(elementToPush);


                                                                })

                                                            }

                                                            if (ageRatingsResponse && ageRatingsResponse.length > 0) {

                                                                ageRatingsResponse.forEach(function (ageRatingElement, indexAgeRating) {

                                                                    let elementToPush = [];


                                                                    elementToPush[0] = ageRatingElement.region;
                                                                    self.state.columnsData.forEach(function (columnElement, indexColumn) {

                                                                        Object.entries(ageRatingElement.ratings).forEach(
                                                                            ([ratingName, value], index) => {
                                                                                if (columnElement.name == ratingName) {
                                                                                    elementToPush[indexColumn] = (value);
                                                                                }
                                                                            }
                                                                        );

                                                                        if (elementToPush[indexColumn] == "" || elementToPush[indexColumn] == null || elementToPush[indexColumn] == undefined) {
                                                                            elementToPush[indexColumn] = "";
                                                                        }


                                                                    });

                                                                    if (ageRatingElement.region == elementToPush[0]) {
                                                                        var existIndex = null;
                                                                        ageRatingsOrdered.forEach(function (ratingEl, index) {
                                                                            if (ratingEl[0] == elementToPush[0]) {
                                                                                existIndex = index;
                                                                            }
                                                                        });

                                                                        if (existIndex != null) {
                                                                            ageRatingsOrdered[existIndex] = elementToPush;
                                                                        }
                                                                    }
                                                                })
                                                            }

                                                            console.log({ageRatingsOrdered});

                                                            self.setState({ageRatingsData: ageRatingsOrdered});

                                                        } else {
                                                            if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                                                self.setState({
                                                                    columnsData: {},
                                                                    errorMessages: response.data.genericMessages
                                                                });
                                                            }
                                                        }
                                                    } else {

                                                    }
                                                } else {

                                                }

                                            }, function () {

                                            })
                                            .catch(function (error) {

                                            });
                                    }, function () {
                                        self.setState({findData: {}})
                                    })
                                    .catch(function (error) {
                                        self.setState({findData: {}})
                                    });
                            });
                        } else {
                            if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                self.setState({
                                    columnsData: {}, errorMessages: response.data.genericMessages
                                });
                            }
                        }
                    } else {

                    }
                } else {
                    self.setState({
                        findData: {}
                    });
                }

            }, function () {
                self.setState({findData: {}})
            })
            .catch(function (error) {
                self.setState({findData: {}})
            });

    }

    _handleKeyPress = (index, event) => {
        if (event.key === 'Enter') {
            console.log(event);
            console.log(index);
            this.state.chipInputs[index] = this.state.chipInputs[index].trim();
            if (this.state.chipInputs[index] && this.state.chipInputs[index] != "") {
                if (this.state.chipInputs[index].length < 25) {
                    let regexp = /^[a-z\d\-,+/_\s]+$/i;
                    if (regexp.test(this.state.chipInputs[index])) {
                        let newStateChipsData = this.state.chipsData;
                        let chipsDataElement = this.state.chipsData[index];
                        console.log(chipsDataElement);
                        if (!chipsDataElement.ageRatings) {
                            chipsDataElement.ageRatings = [];
                        }
                        chipsDataElement.ageRatings.push(this.state.chipInputs[index]);
                        newStateChipsData[index] = chipsDataElement;
                        let newChipInputs = this.state.chipInputs;
                        newChipInputs[index] = "";
                        this.setState({chipsData: newStateChipsData, chipInputs: newChipInputs});
                    } else {
                        this.props.enqueueSnackbar('Please enter valid age rating.', {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                    }
                } else {
                    this.props.enqueueSnackbar('Age rating should be smaller than 25 characters..', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                }

            } else {
                this.props.enqueueSnackbar('Age rating can not be empty.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            }

        }
    };

    render() {
        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};


        const buttonIconStyle = {
            marginRight: theme.spacing(1),
        };

        const containerStyle = {
            minHeight: '650px'
        };
        const formatCardStyle = {
            paddingBottom: '-10px'
        };

        const radioLabelStyle = {
            marginLeft: '-16px',
        };
        const radioStyle = {
            marginRight: '-12px'
        };
        const qualityLabelStyle = {
            marginTop: '10px'
        };

        const buttonProgress = {
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        };

        const progressButtonWrapper = {
            position: 'relative',
        };

        const inputStyle = {
            maxWidth: '7rem'
        };

        const topMargin = {
            marginTop: '25px'
        }

        const regionColumnStyle = {};

        const options = {
            filterType: 'dropdown',
            pagination: false,
            selectableRows: 'none',
            print: false
           // responsive: 'scrollMaxHeight'
        };

        let self = this;

        return (

            <div style={containerStyle}>
                <Dialog fullWidth
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Configure Ratings
                        - {this.state.ratingRegionToEdit}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>

                        </DialogContentText>

                        {this.state.chipsData.map((data, index) => {
                            return (<div>
                                <Typography variant={'subtitle1'}>{data.name}</Typography>
                                {data.ageRatings && data.ageRatings.length > 0 &&

                                <span>{data.ageRatings.map(ageRatingData => {
                                    return <Chip
                                        label={ageRatingData}
                                        className={classes.chip}
                                    />
                                })}</span>}

                                <Input value={self.state.chipInputs[index]}
                                       onKeyPress={self._handleKeyPress.bind(self, index)} onChange={event => {
                                    let newChipInputs = self.state.chipInputs;
                                    newChipInputs[index] = event.target.value;
                                    self.setState({chipInputs: newChipInputs})
                                }}
                                       placeholder="Add Age Rating"
                                       inputProps={{
                                           'aria-label': 'Description',
                                       }}
                                />
                                <br/> <br/>
                                <Divider/>

                            </div>)
                        })}
                        <Typography variant={'caption'}>
                            Please press "Enter" to add rating values.<br/>
                            Ratings once saved, can not be modified or removed.<br/>
                            Only alphabets, numbers,  &nbsp; - &nbsp; +  &nbsp; / &nbsp; are allowed.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.saveRatings.bind(this)} color="primary">
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>

                {sessionStorage.AUTH_MAM_CONFIG == "true" &&
                <Grid container spacing={0}
                      direction="row"
                      justify="space-around"
                      alignItems="center">
                    <Grid item sm={12}>
                        {this.state.columnsData && this.state.columnsData.length > 0
                        && this.state.ageRatingsData && this.state.ageRatingsData.length > 0 &&
                        <MUIDataTable
                            title={"Age Rating Configurations"}
                            data={this.state.ageRatingsData}
                            columns={this.state.columnsData}
                            options={options}
                        />
                        }
                    </Grid>
                </Grid>}

                {!sessionStorage.AUTH_MAM_CONFIG &&
                <Grid container spacing={0}
                      direction="row"
                      justify={'center'}
                      alignItems="center">
                    <Grid item sm={4}></Grid>
                    <Grid item sm={5}>
                        <Typography variant={"h5"}>
                            You are not authorized to access this page.
                        </Typography>

                        <img src="stop.png" width={450} height={453}/>
                    </Grid>
                    <Grid item sm={3}></Grid>
                </Grid>}

                {this.state.errorMessages && this.state.errorMessages.ERROR && this.state.errorMessages.ERROR.length > 0 &&
                <Grid container spacing={0}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={10}>
                        {this.state.errorMessages.ERROR.map((errorMessage, index) => {
                            return (<Typography variant='title' key={index} color='secondary'>
                                Error : {errorMessage.message}
                            </Typography>)
                        })}
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>}
                
                {sessionStorage.AUTH_MAM_CONFIG &&
                <>    
                <Divider/>
                <Grid container spacing={0} style={topMargin}>
                    <Grid item xs={12}>
                        <ContentAdvisoryConfig/>
                    </Grid>
                </Grid>
                </>}
            </div>

        );
    }
}

ConfigContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const ConfContainer = withSnackbar(ConfigContainer);
export default withStyles(styles, {withTheme: true})(ConfContainer);
